// src/components/LoadingOverlay.jsx
import React from "react";
import "../style/LoadingOverlay.css";

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="overlay">
      <div className="spinner"></div>
      <p className="loading-text">Fetching live metro timings...</p>
      <p className="loading-subtext">
        Metro timings shown are approximate and may vary due to real-time operational updates.
      </p>
    </div>
  );
};

export default LoadingOverlay;
